import { render } from "./CreateEditSite.vue?vue&type=template&id=19cac22c"
import script from "./CreateEditSite.vue?vue&type=script&lang=ts"
export * from "./CreateEditSite.vue?vue&type=script&lang=ts"
script.render = render

export default script